module.exports = __webpack_public_path__ + "ed66a98a51c567b06c36c82b592068fc.svg";